/* eslint-disable react/button-has-type */
import useAccount from '@fava/Hooks/useAccount';
import { LocalStorageUtils } from '@fava/Utils/localStorage';
import { FC } from 'react';
import { Link, useHistory } from 'react-router-dom';

const Profile: FC = () => {
  const { data } = useAccount();
  const { push } = useHistory();
  const { setData, setBlockFetch } = useAccount();

  return (
    <div className="block block--mt-1">
      <link
        rel="stylesheet"
        href="https://cdn.jsdelivr.net/npm/bootstrap-icons/font/bootstrap-icons.css"
      />

      <div className="profile d-flex align-items-center">
        {/*        <Link
          className="profile__media profile__media--bordered flex-shrink-0"
          to="/student/avatar">
          <img
            src={data?.avatar?.url || '/static/media/profil.99e89c4ab4ca5aa393ceb04b6485cbeb.svg'}
            alt="img title ChipUser"
          />
          <div className="profile__media-edit">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="32"
              height="32"
              viewBox="0 0 32 32"
              fill="none">
              <path d="M17.1821 6.03763C17.839 5.42763 18.8608 5.44654 19.4947 6.08044L21.9195 8.50524C22.5534 9.13914 22.5723 10.1609 21.9623 10.8178L13.7328 19.6804C13.5436 19.8842 13.2781 19.9999 13 19.9999H9C8.44772 19.9999 8 19.5522 8 18.9999V14.9999C8 14.7219 8.11578 14.4564 8.31955 14.2672L17.1821 6.03763Z" />
              <path d="M8 22.9999C8 22.4477 8.44772 21.9999 9 21.9999H23C23.5523 21.9999 24 22.4477 24 22.9999C24 23.5522 23.5523 23.9999 23 23.9999H9C8.44772 23.9999 8 23.5522 8 22.9999Z" />
            </svg>
          </div>
  </Link> */}
        <div className="profile__text">
          <div className="d-flex align-items-center">
            <div className="profile__name mr-3 " style={{ marginRight: '10px' }}>
              {data?.firstname} {data?.lastname}{' '}
            </div>

            <Link to="/">
              <button
                className="btn btn-primary btn-lg"
                onClick={() => {
                  setData({});
                  setBlockFetch(false);

                  if (localStorage.getItem('session')) {
                    push(`/disconnect-sso`);
                    window.location.reload();
                    LocalStorageUtils.clear();
                    return;
                  }
                  LocalStorageUtils.clear();
                  window.location.reload();
                }}>
                <i className="bi bi-box-arrow-right mr-2" /> Se déconnecter
              </button>
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Profile;
